import GButton from "./";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsPen from "../icons/pen";

const isNotCompact = (display) => display !== "compact";

<template>
  <GButton
    @type={{@type}}
    @color="outline"
    @disabled={{@disabled}}
    @loading={{@loading}}
    @display={{if @display @display "default"}}
    {{mergeClasses}}
    ...attributes
  >
    <div class="flex items-center">
      <IconsPen class="w-3 mr-2 {{if (isNotCompact @display) '-ml-0.5'}} -mt-px text-gray-600" />
      <span>{{yield}}</span>
    </div>
  </GButton>
</template>
